/**
 * Main site navigation tree — shared by ResponsiveMenuBar and /site-menu (no-JS friendly).
 */
export const mainNavPages = [
  { name: "Home", url: "/" },
  {
    name: "Game Servers",
    items: [
      {
        name: "26K Days SMP",
        url: "/26k-days-smp",
        icon: "star",
        preserveCase: true,
        submenuColumns: [
          [
            {
              name: "Getting Started",
              isSection: true,
            },
            { name: "About 26K Days SMP", url: "/26k-days-smp" },
            { name: "Guide", url: "/guide" },
            { name: "Rules", url: "/rules" },
            { name: "SMP Map", url: "/map" },
            { name: "Player Content", isSection: true },
            { name: "Player Warps", url: "/warps" },
            { name: "Real Estate", url: "/real-estate" },
            { name: "User Submissions", url: "/user-submissions" },
            { name: "Pixel Paint 2026", url: "/pixel-paint-2026" },
            { name: "OG Builds", url: "/og-builds" },
          ],
          [
            { isSpacer: true, spacerSize: "section" },
            { isSpacer: true, spacerSize: "item" },
            { isSpacer: true, spacerSize: "item" },
            { isSpacer: true, spacerSize: "item" },
            { isSpacer: true, spacerSize: "item" },
            { isSpacer: true, spacerSize: "divider" },
            { name: "Stats", isSection: true },
            { name: "Markets & Economy", url: "/markets" },
            { name: "Monthly City News", url: "/monthly-stats" },
            { name: "26K Days Player Stats", url: "/stats-smp" },
            { name: "26K Days 2-Year Stats", url: "/stats-two-year" },
          ],
        ],
      },
      {
        name: "Death-ban Vanilla",
        url: "/death-ban-vanilla",
        icon: "science",
        preserveCase: true,
        items: [
          {
            name: "Getting Started",
            isSection: true,
          },
          { name: "About Death-ban Vanilla", url: "/death-ban-vanilla" },
          { name: "Hardcore Guide", url: "/guide-hardcore" },
          { name: "Stats", isSection: true },
          { name: "Player Stats Hardcore", url: "/stats-hardcore" },
        ],
      },
      {
        name: "Creative Plots",
        url: "/creative-plots",
        preserveCase: true,
      },
      {
        name: "Vanilla Experimental",
        url: "/vanilla-experimental",
        preserveCase: true,
      },
    ],
  },
  {
    name: "Community",
    items: [
      { name: "Forums", url: "/forum" },
      { name: "Blog", url: "/blog" },
      { name: "Support", url: "/support" },
      {
        name: "Discord ⤴",
        url: "https://discord.gg/4z6bf9sy44",
        external: true,
      },
    ],
  },
  {
    name: "Store ⤴",
    url: "https://mcverse-store.tebex.io/",
    external: true,
    icon: "store",
  },
  { name: "Vote", url: "/vote", icon: "vote" },
];
